export default __webpack_public_path__ + "static/media/alert-triangle.bf5604da.svg";